import { getStyles } from '@kubit/web-ui-components/utils/getStyles';
import styled from 'styled-components';
export const ParentContainerStyled = styled.div `
  ${({ styles }) => getStyles(styles?.parentContainer)};
`;
export const PagesContainer = styled.div `
  ${({ styles }) => getStyles(styles?.pagesContainer)};
`;
export const PageContainerStyled = styled.section `
  width: ${({ width }) => `${width}px` || '100%'};
  ${({ styles }) => getStyles(styles?.pageContainer)};
`;
export const CanvasContainerStyled = styled.div `
  ${({ styles }) => getStyles(styles?.canvasContainer)};
`;
export const CanvasStyled = styled.canvas `
  display: block;
`;
export const PageContentContainerStyled = styled.div `
  text-align: initial;
  inset: 0;
  ${({ styles }) => getStyles(styles?.pageContentContainer)};
`;
export const PageContentStyled = styled.span.attrs(props => ({
    style: {
        left: `${props.textX}px`,
        bottom: `${props.textY - 3}px`,
        fontSize: `${props.fontSize}px`,
        fontFamily: props.fontFamily,
        transform: `scale(${props.scaleX})`,
    },
})) `
  color: transparent;
  transform-origin: 0% 0%;
  ${({ styles }) => getStyles(styles?.pageContent)};
`;
export const PdfBottom = styled.div `
  width: 100%;
  height: 1px;
  visibility: hidden;
`;
export const IconButtonStickyContainerStyled = styled.div `
  position: sticky;
  bottom: 0;
`;
export const IconButtonContainerStyled = styled.div `
  ${({ styles }) => getStyles(styles?.iconButtonContainer)};
`;
//# sourceMappingURL=pdfViewer.styled.js.map